<template>
    <div>
     
            <iframe src="https://akronenglish.us/enfoques/" width="100%" height="600" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
</template>
<script>
// import axios from '../../helpers/axios'
import {mapState} from 'vuex';


export default {

    components:{
    },

    data: () => ({



    }),


    mounted() {

    },

    computed: {

        ...mapState('globals', ['id_colegio', 'id_usuario']),
        logoColegio() {
        return (this.rutaServer+this.rutaLogo+this.editedItem.logo_colegio)
        }

    },


   //metodos
    methods: {



    }

  }
</script>



<style scoped>


</style>